import {Component} from '@angular/core';
import {Location} from '@angular/common';
import {StateService} from '../../state.service';
import {Tree} from '../../model/tree.model';

@Component({
    selector: 'app-truffle',
    templateUrl: './truffle-found.component.html',
    styleUrls: ['./truffle-found.component.css'],
    standalone: false
})
export class TruffleFoundComponent {
  tree: Tree;

  constructor(private stateService: StateService, private location: Location) {
    this.tree = stateService.tree;
    if (!this.tree) {
      this.location.back();
    }
  }

  back() {
    this.location.back();
  }
}
